export default "__VITE_PUBLIC_ASSET__e75ea5c2__"